import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";
import styles from "../../../styles/report/mobile/reportmobilehead.module.scss";
import { useSelector } from "react-redux";
import {
  getClientProfile,
  getClientReport,
} from "../../../services/clientService";
import DownloadIcon from "../../../assets/dashboard/Menu/download.png";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { useNavigate, useLocation } from "react-router-dom";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { ApiEndpoints, LocalStorageKeys } from "../../../core";

const ClientReportHeadMobile = ({ report }) => {
  const { profile } = useSelector((state) => state.client);
  const [isExpanded, setIsExpanded] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedYear, setSelectedYear] = useState("all");

  const navigate = useNavigate();
  const location = useLocation();
  const hasReports = Array.isArray(report) && report.length > 0; // ✅

  useEffect(() => {
    getClientProfile();
  }, []);

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    // Check if date is valid
    if (isNaN(date.getTime())) {
      return "";
    }

    return date.toLocaleDateString("en-GB", {
      timeZone: "Asia/Dubai",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  const formatTime = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return "";
    }

    return date.toLocaleTimeString("en-GB", {
      timeZone: "Asia/Dubai",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    });
  };

  const clientData = {
    lastTestDate: formatDate(profile?.lastReportTestedAt || ""),
    lastTestTime: formatTime(profile?.lastReportTestedAt || ""),
  };
  const handleYearFilter = async (e) => {
    const year = e.target.value;
    setSelectedYear(year);

    try {
      // Show loading state
      setIsDisabled(true);

      const success = await getClientReport(year);
    } catch (error) {
      console.error("Year filter error:", error);
      toast.error("Failed to filter reports by year");
    } finally {
      setIsDisabled(false);
    }
  };

  // const handleDownloadPDF = async () => {
  //   const clientId = profile?._id;
  //   if (!clientId) {
  //     console.error("Client ID not found.");
  //     return;
  //   }

  //   const downloadUrl = `https://server.ttrprogramming.com/api/v1/fitness-report/download/client/${clientId}`;

  //   if (!report || report.length === 0) {
  //     toast.warning("No report available to generate PDF.");
  //   } else {
  //     toast.success("Waiting for download report..");
  //     // setIsDisabled(true);

  //     try {
  //       const response = await fetch(downloadUrl); // ✅ Fetch from URL
  //       if (!response.ok) {
  //         throw new Error("Failed to fetch PDF");
  //       }

  //       const blob = await response.blob(); // ✅ Convert response to blob
  //       const blobUrl = window.URL.createObjectURL(blob);

  //       const a = document.createElement("a");
  //       a.href = blobUrl;
  //       a.download = `fitness-report-${clientId}.pdf`; // ✅ File name for download
  //       document.body.appendChild(a);
  //       a.click();

  //       a.remove();
  //       window.URL.revokeObjectURL(blobUrl); // ✅ Clean up
  //       // setIsDisabled(false);
  //     } catch (error) {
  //       console.error("PDF download failed:", error);
  //       // setIsDisabled(false);
  //     }
  //   }
  // };

  const handleDownloadPDF = async () => {
    if (!hasReports) {
      toast.error("No reports found to download for the selected year.");
      return;
    }
    const clientId = profile?._id;
    const clientName = profile?.name;
    if (!clientId) {
      console.error("Client ID not found.");
      return;
    }
    const token = localStorage.getItem(LocalStorageKeys.clientToken);

    const downloadUrl = `${ApiEndpoints.baseApiURL}/fitness-report/download/client`;
    toast.success("Preparing download...");
    setIsDisabled(true);
    try {
      const response = await fetch(downloadUrl, {
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }); // ✅ Fetch from URL
      if (response.status === 204) {
        toast.error("No reports found to download.");
        return;
      }
      if (!response.ok) {
        throw new Error("Failed to fetch PDF");
      }
      const blob = await response.blob();
      if (!blob.size) {
        toast.error("No reports found to download.");
        return;
      } // ✅ Convert response to blob
      const blobUrl = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = blobUrl;
      a.download = `${clientName}-${selectedYear}-report.pdf`; // ✅ File name for download
      document.body.appendChild(a);
      a.click();

      a.remove();
      window.URL.revokeObjectURL(blobUrl); // ✅ Clean up
      setIsDisabled(false);
    } catch (error) {
      console.error("PDF download failed:", error);
      setIsDisabled(false);
    }
  };

  const handleBack = () => {
    navigate("/");
  };

  const toggleExpansion = () => {
    setIsExpanded(!isExpanded);
  };
  // Generate year options
  const currentYear = new Date().getFullYear();
  const startYear = 2025;
  const yearOptions = [];

  for (let year = currentYear; year >= startYear; year--) {
    yearOptions.push({
      value: year.toString(),
      label: year === currentYear ? `${year}` : year.toString(),
    });
  }
  return (
    <div className={styles.container}>
      {/* Header Section */}
      <div className={styles.buttonGroup}>
        <div className={styles.buttonGroupchildone}>
          <h1 className={styles.title}>
            {" "}
            <span
              style={{
                display: location.pathname === "/scoreboard" ? "" : "none",
              }}
              onClick={handleBack}
            >
              <MdOutlineKeyboardArrowLeft size={"1.4em"} color="#fff" />
            </span>{" "}
            CLIENT REPORT
          </h1>
        </div>
        <div className={styles.buttonGroupchildtwo}>
          <select
            className={styles.sortselect}
            value={selectedYear}
            onChange={handleYearFilter}
            disabled={isDisabled}
          >
            <option disabled value="all">
              Select Years
            </option>
            {yearOptions.map((yearOption) => (
              <option
                defaultChecked
                key={yearOption.value}
                value={yearOption.value}
              >
                {yearOption.label}
              </option>
            ))}
          </select>
          <button
            disabled={isDisabled}
            onClick={handleDownloadPDF}
            className={styles.downloadButton}
          >
            <div className={styles.downloadIconWrapper}>
              <span className={styles.downloadIcon}>
                <img src={DownloadIcon} alt="download.png" />
              </span>
            </div>
            <span className={styles.downloadText}>Download</span>
          </button>
        </div>
      </div>

      {/* Client Information Section */}
      <div className={styles.clientInfo}>
        <div className={styles.clientInfoHeader} onClick={toggleExpansion}>
          <div className={styles.basicInfo}>
            <div className={styles.infoRow}>
              <span className={styles.label}>Name :</span>
              <span className={styles.value}>{profile?.name || ""}</span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.label}>ID :</span>
              <span className={styles.value}>{profile?.code || ""}</span>
            </div>
          </div>
          <div className={styles.toggleIcon}>
            <span className={isExpanded ? styles.arrowUp : styles.arrowDown}>
              {isExpanded ? (
                <IoIosArrowUp size={"1.3em"} color="#fff" />
              ) : (
                <IoIosArrowDown size={"1.3em"} color="#fff" />
              )}
            </span>
          </div>
        </div>

        {/* Expandable Section */}
        {isExpanded && (
          <div className={styles.expandedInfo}>
            <div className={styles.infoRow}>
              <span className={styles.label}>Gender :</span>
              <span className={styles.value}>{profile?.gender || ""}</span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.label}>DOB :</span>
              <span className={styles.value}>{profile?.dob || ""}</span>
            </div>
            <div className={styles.infoRow}>
              <span className={styles.label}>Last Test Date :</span>
              <span className={styles.value}>{clientData.lastTestDate}</span>
            </div>
            {/* <div className={styles.infoRow}>
              <span className={styles.label}>Time :</span>
              <span className={styles.value}>{clientData.lastTestTime}</span>
            </div> */}
          </div>
        )}
      </div>
    </div>
  );
};

export default ClientReportHeadMobile;
